import { IconProps } from '@models/icons';

function IncreaseIcon({ size, color, ...rest }:IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <circle cx="9.16667" cy="9.99992" r="9.16667" fill={color} fillOpacity="0.45"/>
            <path d="M9.33333 5V13.75" stroke="white" strokeWidth="2" strokeLinecap="round"/>
            <path d="M4.95833 9.375L13.7083 9.375" stroke="white" strokeWidth="2" strokeLinecap="round"/>
        </svg>
    );
}

export default IncreaseIcon;
